import { Injectable } from '@angular/core';
import { DecimalPlaces, STORED_DECIMAL_PLACES } from '@shared/models/decimal-places';

@Injectable({
  providedIn: 'root'
})
export class MoneyHelper {

  round(value: number, noOfDecimals: number = 2) {
    if (!value) {
      return 0;
    }
    const roundingFactor = Math.pow(10, noOfDecimals);
    // return Math.round(value * roundingFactor) / roundingFactor;
    const scaledValue = Math.abs(value * roundingFactor);

    // (70.725 * 100) % 1 =            0.4999999999990905
    // (70.87499999999999 * 100) % 1 = 0.499999999998181
    let roundedValue = 0;
    if (scaledValue % 1 >= 0.49999999999)
      roundedValue = Math.ceil(scaledValue) / roundingFactor;
    else
      roundedValue = Math.floor(scaledValue) / roundingFactor;

    return value > 0 ? roundedValue : (roundedValue * -1);
  }

  /**
   * The only rounding a write path may do: strip float noise (`0.1 + 0.2`) at the storage width.
   * Never used to match what a screen shows — a display setting is a mask over this value.
   */
  toStored(value: number, kind: keyof DecimalPlaces = 'amount'): number {
    return this.round(value, STORED_DECIMAL_PLACES[kind]);
  }

}
